import { render, staticRenderFns } from "./ConfirmRegistration.view.vue?vue&type=template&id=39fef542&"
import script from "./ConfirmRegistration.view.vue?vue&type=script&lang=js&"
export * from "./ConfirmRegistration.view.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmRegistration.view.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports